import Label from "components/general/Label"
import { filterArray, findArray } from 'helpers/utils'
import { ResultRankDiffOws } from "components/presentation/ResultRank"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
import SportCode from "components/common/SportCode"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";





export function hasConfig(config) {
    let sw = config.filter(rowConf => rowConf.code === 'INTERMEDIATE').length > 0
    return (
        sw
    )
}

export function createColumnsIntermediate(columnsAdded, isFinish) {
    let numCols = findArray(columnsAdded, { code: ['INTERMEDIATES_NUM'], type: ['EC'] }).value
    let config = filterArray(columnsAdded, { code: ['INTERMEDIATE'] })
    config = config.filter((item) => item.pos !== 'S');
    let columnsExt = []

    config.map((item) => {
        const { mirs_discipline } = useUrlFriendlyToParameters()
        let type = findArray(item?.extension, { code: ['NAME'] })?.value
        let lap = (type !== undefined)
            ? <> <SportCode code={type} discipline={mirs_discipline} entity="@IntPtType" /></>
            : ''

        let split = item.pos === 'F' ? numCols : item.pos;
        let header = item.pos === 'F'
            ? <Label data="HeaderFinish" />
            : <>
                <div className="flex">
                    <div>{lap}</div>
                </div>
                {item.value}<Label data="LabelKm" />
            </>

        columnsExt.push(

            {
                Header: header,
                accessor: (props) => (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [item.pos] }).er_sortorder
                        : ''
                ),

                Cell: (props) => (
                    getCell(isFinish, props.cell.row.original, item.pos)
                ),
                isVisible: false,
                disableSortBy: false,
                columnIndex: split,
                id: 'Splits-' + split,
                className: 'result',
                headerClassName: 'text-center w-10',
                sortType: "absoluteOrderNumber"
            },

        )
    })

    return columnsExt
}

function getCell(isFinish, row, split) {

    let cell = null

    if (!!row) {

        let intermediate = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [split] })
        let resultIrm = row.resultIrm
        let difference = split === 'F' && resultIrm === 'REL'
            ? resultIrm
            : intermediate.er_diff
        let card = intermediate?.extensions ? intermediate?.extensions.find(ere => ere.ere_code === 'FLAG').ere_value : ''

        if (card === 'Y')
            card = <FontAwesomeIcon icon={faSquare} color='yellow' />

        let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value

        if ((photo === undefined || split !== 'F' || photo === 'E' || isFinish) && resultIrm !== 'DSQ') {
            cell = <ResultRankDiffOws card={card} result={intermediate?.er_value} rank={intermediate.er_rank} diff={difference} />
        }

    }

    return cell



}
